import styled from "styled-components"

export const BalloonMessageWrapper = styled.div`
    position: fixed;
    width: 375px;
    top: 20px;
    right: 20px;
    border-radius: 16px;
    opacity: 0;
    background: rgba(0,0,0, 0.8);
    color: white;
    z-index: 1000;

    &.show {
        opacity: 1;
        transition: 0.4s ease;

        &.removing {
            opacity: 0;
            transition: 0.2s ease;
        }
    }
`
export const Message = styled.div`
    display: flex;
    padding: 10px 15px;
`
export const MessageBody = styled.div`
    display: flex;
    flex-grow: 1;
`
export const MessageClose = styled.div`
    display: flex;
    align-items: center;
    height: 21px;
    margin-left: 5px;
`
